<template>
    <div style="width: 100vw; height: 100vh">
        <Cockpit v-if="loaded" @loadedPanorama="onPanoramaLoaded"/>
        <div v-if="overlay" class="loadingOverlay">
            <!--        <ImageLoader-->
            <!--            ref="imageLoader"-->
            <!--            v-if="sphereTexture"-->
            <!--            :images="[sphereTexture]"-->
            <!--            @loaded="onImagesLoaded"-->
            <!--            @progress="loadingProgress = $event"-->
            <!--            style="display: none"-->
            <!--        />-->
            <img style="width: 100vw; height: 100vh; object-fit: cover; object-position: center"
                 :src="backgroundImageUrl" @load="onBackgroundLoaded" />

            <LoadingAsset style="position: absolute; top: 0">
                    <div style="display: flex">
                        <img style="margin-top: 8px; width: 30px; height: 30px; margin-right: 10px" :src="loadingIcon">

                        <div style="display: inline-block;">
                            Loading Assets... {{ loadingProgress === 0 ? '' : `(${loadingProgress}%)` }}
                        </div>
                    </div>
                </LoadingAsset>
        </div>
    </div>
</template>

<script>
import Cockpit from "@/views/Cockpit";
import TrinityRings from "@/components/Spinners/TrinityRings";
import {textureLoader} from "@/modules/LAT/panorama";
import Vue from "vue";
import {initLAT} from "@/modules/LAT/LAT_main";
import {aircraftConfig, LufthansaColors} from "@/config";
import ImageLoader from "@/components/ImageLoader";
import LoadingAsset from "@/components/LoadingAsset";
import LoadingCards from "@/components/LoadingCards";

export default {
    name: "CockpitLoader",
    components: {Cockpit, LoadingAsset},
    data: () => ({
        overlay: true,
        loaded: false,
        initRoomStarted: false,
        loadingProgress: 0,
        procedures: [],
        spots: [],
        loadingIcon: require('../assets/images/airplane.gif')
    }),
    computed: {
        sphereTexture() {
            return this.$store.state.sphereTexture;
        },
        backgroundImageUrl: () => aircraftConfig.assetUrl + 'airplanes/B787/787_sky_Startscreen.jpg',
    },
    mounted() {
        setTimeout(this.onBackgroundLoaded.bind(this), 5000); // backup if background image loading fails
    },
    methods: {
        onBackgroundLoaded(){
            if(this.initRoomStarted){
                return;
            }
            this.initRoomStarted = true
            const roomId = this.$router.currentRoute.params.aircraft
            if (roomId) {
                this.$store.dispatch('loadCockpitFromAPI', roomId).then(() => {
                    this.initRoom(this.sphereTexture)
                })
            }
        },
        initRoom(texture) {
            this.$store.commit('SAVE_LOADED_TEXTURE', {
                key: 'sphere', texture
            })
            Vue.prototype.$LAT = initLAT(this.$store.state.cockpit);
            Vue.prototype.$colors = LufthansaColors;
            this.loaded = true;
        },
        onImagesLoaded(images) {
            const texture = images[0]
            this.initRoom(texture)
        },
        onPanoramaLoaded() {
            this.overlay = false
        }
    }
}
</script>

<style scoped>

.loadingOverlay{
    position: absolute;
    left: 0;
    top:0;
    height: 100vh;
    width: 100vw;
}

.img-container {
    position: relative;
    overflow: hidden;
}

.background-image {
    position: absolute;
    min-width: 1000%;
    min-height: 1000%;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%) scale(0.1);
    z-index: -1;
}

</style>
